export default {"src":"/_next/static/media/email.5729a8dd.svg","height":21,"width":31,"blurWidth":0,"blurHeight":0};